import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@kodit/core/services';
import { DynamicDialogRef } from '@kodit/core/shared-ui';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-nova-verzija-force-dialog',
  templateUrl: './nova-verzija-force-dialog.component.html',
})
export class NovaVerzijaForceDialogComponent implements OnInit, OnDestroy {
  private _subs = new Subscription();

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _authService: AuthService,
  ) {}

  ngOnInit(): void {
    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._dialogRef.close();
        this._authService.logout();
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
